import {
  StyledIconContainer,
  StyledNotificationCountCircle,
  StyledTextContainer,
  StyledToggleButton,
} from './styled';
import { ToggleButtonType } from './ToggleButtonType';

export interface ToggleButtonProps {
  onClick?: () => void;
  toggled?: boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
  text?: string;
  type?: ToggleButtonType;
  mobileOnly?: boolean;
  desktopOnly?: boolean;
  notificationCount?: number;
  color?: string;
  className?: string;
  noMobileText?: boolean;
  ariaLabel?: string;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  onClick,
  toggled,
  disabled,
  icon,
  text,
  type = ToggleButtonType.Vertical,
  mobileOnly,
  desktopOnly,
  notificationCount,
  color,
  className,
  noMobileText,
  ariaLabel,
}) => (
  <StyledToggleButton
    buttonType={type}
    disabled={disabled}
    mobileOnly={mobileOnly}
    desktopOnly={desktopOnly}
    onClick={onClick}
    className={className}
    toggled={toggled}
    color={color}
    aria-label={ariaLabel}>
    {type !== ToggleButtonType.Text && (
      <StyledIconContainer
        toggled={toggled}
        color={color}
        noMobileText={noMobileText}
        buttonType={type}>
        {icon}
        {notificationCount !== undefined && notificationCount > 0 && (
          <StyledNotificationCountCircle>
            {notificationCount}
          </StyledNotificationCountCircle>
        )}
      </StyledIconContainer>
    )}
    {type !== ToggleButtonType.Icon && (
      <StyledTextContainer
        toggled={toggled}
        color={color}
        noMobileText={noMobileText}>
        {text}
      </StyledTextContainer>
    )}
  </StyledToggleButton>
);
